import React, { useState } from "react";
import IconRoundButton from "../CommonButtons/IconRoundButton";
import { IntervalConfiguration } from "../../../utils/configurationProvider";
import PrimaryButton from "../CommonButtons/PrimaryButton";
import axiosInstance from "../../../redux/globalInspector/axiosInstance";
import axios from "axios";
import { toast } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization";
import ICONS from "../../../assets/Icons";

const MediumImagePopup = ({ closehandleFunction, image }) => {
  const [animate, setAnimate] = useState(false);
  const handleClose = () => {
    closehandleFunction();
  };
  const handleDownload = async (urlData, filename) => {
    // try {
    //   const response = await axios.get(`${urlData}`, {
    //     headers: {
    //       "Content-Type": "application/json",
    //       "X-Api-Key": sessionStorage.getItem("q2p_token"),
    //     },
    //     responseType: "blob",
    //   });
    //   let blob = response.data;
    //   const url = window.URL.createObjectURL(blob);
    //   const link = document.createElement("a");
    //   link.href = url;

    //   link.setAttribute("download", `${filename}`);

    //   document.body.appendChild(link);

    //   link.click();

    //   document.body.removeChild(link);
    //   window.URL.revokeObjectURL(url);
    // } catch (error) {
    //   console.log(error);
    // }
    toast.info("Feature coming soon", toast_position);
  };

  return (
    <div
      className="flex w-full justify-center items-center m-auto top-1/2 left-1/2 fixed z-z-index-modal p-padding-sm"
      style={{ transform: "translate(-50%, -50%)" }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={`h-fit w-full h-popup-height max-h-assign-tag-popup-height overflow-hidden relative Qmd:w-max-content-width flex flex-col pt-padding-md bg-primary-bg rounded-border-radius-md animate-none ${animate ? "Qmd:animate-slideInFromLeft" : "Qmd:animate-slideInFromRight"}`}
      >
        <div>
          <div className=" flex flex-col gap-gap-xs px-padding-md">
            <div className="flex justify-between gap-gap-md ">
              <div className=" flex gap-gap-sm">
                <div className="flex flex-col gap-gap-xs">
                  <p className="text-font-md text-text-primary font-semibold">
                    Image preview
                  </p>
                </div>
              </div>
              <IconRoundButton
                enabledBgColor={"var(--primary-nav-act)"}
                isLoading={false}
                handleFunction={() => {
                  if (!false) {
                    setAnimate(true);
                    setTimeout(() => {
                      handleClose();
                    }, IntervalConfiguration.intervalSemiMid);
                  }
                }}
                title="Close"
                icon={ICONS?.CLOSE}
                hoverOption="white"
                btnType={"button"}
                isDisabled={false}
                disabledBgColor={""}
                // buttonRef={closebuttonRef}
                // imgColor={closeimgColor}
              />
            </div>
          </div>
        </div>
        <div className="w-width-full h-height-full flex justify-center items-center px-padding-md flex-1 max-h-image-popup-height mt-margin-md">
          <img
            alt=""
            src={image?.url}
            // style={{ width: "100px", height: "50px" }}
            style={{
              objectFit: "contain",
              width: "100%",
              height: "100%",
            }}
          />
        </div>
        {/* <div className="py-padding-md flex pr-padding-md self-end">
          <PrimaryButton
            enabledBgColor="var(--positive-act)"
            btnText="Download"
            enabledTextColor="var(--text-primary)"
            handleFunction={() => handleDownload(image?.url, image?.name)}
            hoverOption="white"
            isDisabled={true}
          />
        </div> */}
      </div>
    </div>
  );
};

export default MediumImagePopup;
